import { Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private itemsPerPage = 5;
  private currentPage = 5;

  private notificationItems = [
    {
      "date": "03/09/2026",
      "title": "Novo quadro 6.1/2 do Formulário de Referência (FRe)",
      "preview": `A B3 e CVM informam que, a partir de 03/10/2026, o quadro 6.1/2 do Formulário de Referência (FRe) terá um novo layout, que facilitará a dinâmica de seu preenchimento, tornando-o mais responsivo.
      <br><br> Dessa forma, para reapresentações, o sistema direcionará, automaticamente, as informações já prestadas no referido quadro, constantes da última versão, para a nova estrutura.
      <br><br> Adicionalmente, a partir de 03/10/2026, o relatório completo do FRe apresentará uma nova formatação, inclusive, com índice remissivo.
      <br><br> Qualquer dúvida, nossa Superintendência de Atendimento de Listados está à disposição para auxiliar, pelo telefone (11) 2565-5063 ou por e-mail: <a class=\"link-external-b3\" href=\"mailto:emissores.empresas@b3.com.br\">emissores.empresas@b3.com.br</a>
      <br><br> Até breve,
      <br><br> Equipe B3 – Portfolio de Emissores e Ofertas.`,
      "expirationDate": "2026-10-19"
    },
    {
      "date": "16/10/2026",
      "title": "Novos horários de negociação",
      "preview": `A partir de 03/11/2026, teremos mudanças nos horários de negociação dos mercados de bolsa e de balcão organizado administrados pela B3, devido ao término do horário de verão nos Estados Unidos, Alemanha e Inglaterra.
      <br><br> Dessa forma, as negociações no mercado de ações terão início às 10h00 e encerramento às 17h55.
      <br><br> Para conhecer as grades horárias dos demais mercados, <a class=\"link-external-b3\" href=\"https://www.b3.com.br/data/files/99/B7/82/67/8A631A103BBB511AAC094EA8/OC%20050-2026-VNC%20NOVOS%20HORARIOS%20DE%20NEGOCIACAO_PT.pdf\" target=\"_blank\" rel=\"noopener noreferrer\"><b>clique aqui.</b></a>`,
      "expirationDate": "2026-11-30"
    }
  ];
  // .map((item, index) => ({
  //   ...item,
  //   id: index + 1,
  //   title: `Aviso ${(index + 1).toString().padStart(2, '0')} - ${ item.title } `
  // }));

  get visibleNotifications(): any[] {
    return this.notificationItems.slice(0, 5);
  }

  get itemCount(): number {
    return this, this.notificationItems.length
  }

  get getNotifications(): any {
    return this.notificationItems;
  }

  constructor() {
    this.updateNotificationItems();
  }

  // Função para filtrar itens que ainda não expiraram e formatar os títulos
  private updateNotificationItems() {
    const currentDate = new Date(); // Data atual
    this.notificationItems = this.notificationItems
      .filter(item => new Date(item.expirationDate) >= currentDate) // Filtra itens que não expiraram
      .map((item, index) => ({
        ...item,
        id: index + 1, // Define o ID
        title: `Aviso ${(index + 1).toString().padStart(2, '0')} - ${item.title} ` // Formata o título
      }));
  }

  getPaginatedNotifications(page: number): any[] {
    const startIndex = page * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.notificationItems.slice(startIndex, endIndex)
  }

  getTotalPages(): number {
    return Math.ceil(this.notificationItems.length / this.itemsPerPage);
  }

  setPage(page: number): void {
    if (page > 0 && page < this.getTotalPages()) {
      this.currentPage = page;
    }
  }

  getNotificationByIndex(index: number): any {
    return this.notificationItems[index];
  }

  getNotificationIndex(notification: any): number {
    return this.notificationItems.findIndex(item =>
      item.date === notification.date && item.title === notification.title
    );
  }
}
